import React from 'react';
import { Box } from '@latitude/box';
import { Hero } from '@latitude/hero';
import { Lframe } from '@latitude/lframe';
import { BREAKPOINT, COLOR } from '@latitude/core/utils/constants';
import lframeBGImage from './images/lframe-pay-any-way.png';

const PAWHero = ({
  title = 'Digital wallets',
  text = 'You can pay any way on your phone or wearable tech device with just a tap.'
}) => (
  <Box backgroundColor={COLOR.GREY6}>
    <Lframe
      css={`
        height: 500px;
        background-image: url(${lframeBGImage});
        background-size: contain;
        background-position: top right;
        margin-top: 55px;
        @media (min-width: ${BREAKPOINT.LG}) {
          height: 656px;
          margin-top: 80px;
        }
      `}
    />
    <Hero
      title={title}
      text={text}
      css={`
        padding: 50px 0 0;
        @media (min-width: ${BREAKPOINT.LG}) {
          .HeroContent {
            align-items: center;
            display: flex;
            min-height: 450px; /* As per UX team request */
          }
        }
      `}
    />
  </Box>
);

export default PAWHero;
